import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Spinner } from '@mssgme/ui';

import styles from './ImageUploadCover.scss';

export default function ImageUploadCover({
    className,
    accept,
    name,
    onChange,
    buttonLabel,
    previewUrl,
    isUploading,
    onApplyClick,
    active,
}) {
    const { t } = useTranslation('ui');

    return (
        <div className={className}>
            <div className={styles.root}>
                <div className={styles.coverPreview}>
                    {previewUrl && <img src={previewUrl} alt="Cover" />}
                    {!previewUrl && <span className={styles.emptyMessage}>{t('ImageUploadCover.empty')}</span>}
                    <div className={styles.buttons}>
                        <div className={styles.button} style={{ marginRight: 'auto' }}>
                            {isUploading && <Spinner size={16} color="black" />}
                            {!isUploading && (
                                <>
                                    {buttonLabel}
                                    <input
                                        type="file"
                                        className={styles.fileInput}
                                        accept={accept}
                                        name={name}
                                        onChange={onChange}
                                    />
                                </>
                            )}
                        </div>
                        {!active && !!previewUrl && (
                            <div className={styles.button} onClick={onApplyClick}>
                                {t('ImageUploadCover.enable')}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

ImageUploadCover.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    accept: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    previewUrl: PropTypes.any,
    isUploading: PropTypes.bool.isRequired,
    buttonLabel: PropTypes.string,
    onApplyClick: PropTypes.func.isRequired,
    active: PropTypes.bool.isRequired,
};

ImageUploadCover.defaultProps = {
    className: '',
    buttonLabel: 'Upload',
    previewUrl: null,
};
